/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */

import { type ChangeEvent, useState } from 'react';
import { Typography, Grid, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { strings } from 'i18n/Strings';
import { useDispatch } from 'react-redux';
import { setSnackBarFailed, setSnackBarSuccess } from 'store/snackBar';
import { exportOrdersReport } from 'service/OrderService';
import { transactionTypes } from 'constants/constantText';

const BuyOrders = (): JSX.Element => {
  const [date, setDate] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleExportBuyReport = async (): Promise<void> => {
    setLoading(true);
    if (!date) {
      setLoading(false);
      dispatch(
        setSnackBarFailed({
          snackBarMessage: strings.displayText.noReportDateError,
        }),
      );
      return;
    }
    try {
      const url = await exportOrdersReport(transactionTypes.buy, date);
      const link = document.createElement('a');
      link.href = url as string;
      link.download = `Orders_Report_BUY_${date}`;
      link.click();
      dispatch(
        setSnackBarSuccess({
          snackBarMessage: strings.displayText.buyOrderReportExportSuccess,
        }),
      );
    } catch (error) {
      console.log('Error in exporting buy order');
      dispatch(
        setSnackBarFailed({
          snackBarMessage: strings.displayText.buyOrderReportExportFailed,
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSetDate = (e: ChangeEvent<HTMLInputElement>): void => {
    setDate(e.target.value);
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h4" component="h2" sx={{ marginBottom: 2 }}>
          {strings.displayText.dailyReportBuyLabel}
        </Typography>
      </Grid>
      <Grid item sx={{ minWidth: 250 }}>
        <TextField
          type="date"
          value={date}
          onChange={handleSetDate}
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />
      </Grid>
      <Grid item>
        <LoadingButton
          loading={loading}
          variant="contained"
          onClick={handleExportBuyReport}
        >
          {strings.displayText.export}
        </LoadingButton>
      </Grid>
    </Grid>
  );
};

export default BuyOrders;
